import React, { useState } from "react";
import { StyledPageFormatter } from "./PageFormatter.styled";
import { Header } from "../Header/Header";
import { Sidebar } from "../Sidebar/Sidebar";
import { Outlet } from "react-router";
import { useDimensions } from "../../hooks/useDimensions.hook";

type PageFormatterProps = {
  loadAppData: () => Promise<void>;
  setDataLoaded: (loaded: boolean) => void;
  logout: () => void;
};

export const PageFormatter = ({
  loadAppData,
  setDataLoaded,
  logout,
}: PageFormatterProps) => {
  const { isMobile } = useDimensions();
  const [showSidebar, setShowSidebar] = useState(!isMobile);

  return (
    <StyledPageFormatter>
      {showSidebar && (
        <div
          className="sidebar-overlayer show-mobile"
          onClick={() => setShowSidebar(!showSidebar)}
        />
      )}
      <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className={`right-content ${showSidebar ? "open" : "close"}`}>
        <Header
          loadAppData={loadAppData}
          setDataLoaded={setDataLoaded}
          logout={logout}
          onOpenSidebar={() => setShowSidebar(true)}
        />
        <div className="page-container">
          <Outlet />
        </div>
      </div>
    </StyledPageFormatter>
  );
};
